import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './';
import { Order } from '@cl/shared/models/orders/order.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { lastValueFrom } from 'rxjs';
import { OrderFilter } from '@cl/shared/models/orders/order-filter.model';
@Injectable({
    providedIn: 'root',
})
export class OrdersService extends BaseServiceWithFilter<Order, OrderFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/orders/');
    }

    async getOrderByOrderNumber(orderNumber: string): Promise<CommandResult<Order>> {
        return lastValueFrom(
            await this.httpClient.get<CommandResult<Order>>(`${this.baseApiUrl}by-number`, { params: { orderNumber: orderNumber } }),
        );
    }

    async searchOrdersByQuery(searchQuery: HttpParams): Promise<CommandResult<Order[]>> {
        return lastValueFrom(await this.httpClient.get<CommandResult<Order[]>>(`${this.baseApiUrl}search-by-query`, { params: searchQuery }));
    }

    // Tikai pasūtījumi, kuros darbiniekam ir aktīvs darbs visā rīkojuma periodā — no pašreizējām formas vērtībām.
    async getForHrOrder(performerIds: number[], dateFrom: Date | string, dateTo: Date | string, searchText: string): Promise<Order[]> {
        let params = new HttpParams();

        performerIds.forEach((id) => (params = params.append('performerIds', `${id}`)));

        params = params.append('searchText', searchText ?? '');

        if (dateFrom) {
            params = params.append('dateFrom', this.toHttpParamValue(dateFrom));
        }

        if (dateTo) {
            params = params.append('dateTo', this.toHttpParamValue(dateTo));
        }

        const result = await lastValueFrom(
            this.httpClient.get<CommandResult<Order[]>>(`${this.baseApiUrl}for-hr-order`, {
                params: params,
            }),
        );

        return result?.data ?? [];
    }

    toString(order: Order): string {
        return order.number;
    }
}
